import { Grid, styled } from "@mui/material";

export const StatusContainer = styled(Grid)({
  display: "flex",
  alignItems: "center",
  gap: "5px",
});
